<template>
  <div>
    <van-nav-bar
      title="动态"
      left-text="返回"
      left-arrow
      fixed
      placeholder
      @click-left="onClickLeft"
    />
    <!-- 帖子列表 -->
    <topic-item :type="true" />
  </div>
</template>

<script>
// @ is an alias to /src
import { NavBar } from "vant";

export default {
  name: "more-info",
  components: {
    [NavBar.name]: NavBar,
    topicItem: () => import("../components/table-list")
  },
  methods: {
    onClickLeft() {
      this.$router.push({ path: "/" });
    }
  }
};
</script>

<style scoped>
.find_top {
  width: 100%;
  height: 11vw;
}
@import "../assets/common.css";
</style>
